<template>
  <div>
    <NavigationBar
      :actions="actions"
      :backRoute="backRoute"
      :tabs="tabs"
      :activeTab="activeTab"
      @active-tab-updated="activeTab = $event"
      showBackBtn
      isPreview
    >
      <template v-slot:title>
        <div class="">
          <small class="mb-0 pb-0 grey--text font-weight-medium caption"
            >Personaldaten</small
          >
          <div class="mt-n1 pt-0 pb-2 title text-h6 font-weight-medium">
            {{ personnelRecord.firstName }}
            {{ personnelRecord.lastName }}

            <person-switcher-selector-menu
              v-model="currentSelection"
              :items="personnelRecords"
            >
            </person-switcher-selector-menu>
          </div>
        </div>
      </template>
    </NavigationBar>
    <router-view :personnelRecord="personnelRecord" />
  </div>
</template>

<script>
import { db } from "@/firebase";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import PersonSwitcherSelectorMenu from "@/components/_system/helpers/PersonSwitcherSelectorMenu.vue";
// import Subheader from "@/components/_systemwide/Subheader.vue";

import {
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_GENERAL_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CONTACT_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CHRONICLE_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CERTIFICATES_update,
  // MEMBER_MANAGEMENT_PERSONNEL_RECORDS_PHYSICALS_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_EMERGENCY_CONTACTS_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_ACCOUNTING_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_ATTENDANCE_update,
  MEMBER_MANAGEMENT_PERSONNEL_RECORDS_YOUTH_GROUP_update,
} from "@/data/permission-types.js";

export default {
  name: "member-management-personnel-records-details",
  components: {
    NavigationBar,
    // Subheader,
    PersonSwitcherSelectorMenu,
  },
  data() {
    return {
      actions: [
        {
          title: "Bearbeiten",
          permissions: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_update}`,
          icon: "mdi-pencil",
          actionStyle: "textBtn",
          function: this.editItem,
        },
        // {
        //   title: "Aktionen",
        //   icon: "mdi-dots-horizontal-circle",
        //   actionStyle: "textBtnMultiple",
        //   list: [
        //     {
        //       title: "E-Mail senden",
        //       icon: "mdi-email",
        //       disabled: true,
        //       function: this.createItem,
        //     },
        //     {
        //       title: "Datensatz sperren",
        //       icon: "mdi-lock",
        //       disabled: true,
        //       function: this.createMultiple,
        //     },
        //     { divider: true },
        //     {
        //       title: "Kontakt als vCard exportieren ",
        //       icon: "mdi-file-export",
        //       disabled: true,
        //       function: this.createFromCSV,
        //     },
        //     {
        //       title: "Drucken",
        //       icon: "mdi-printer",
        //       disabled: true,
        //       function: this.printItem,
        //     },
        //   ],
        // },

        // { divider: true },
        { actionStyle: "clipboardBtn" },
      ],

      currentSelection: "",

      activeTab: `general`,
      personnelRecord: {
        id: null,
        salutation: null,
        letterSalutation: null,
        title: null,
        firstName: null,
        lastName: null,
        birthday: null,
        birthdate: null,
        photoUrl: null,

        memberSince: null,
        memberUntil: null,
        dutyPosition: {
          badgeUrl: {
            size70x70: null,
            size125x125: null,
          },
          title: null,
          since: null,
        },
        rank: {
          badgeUrl: {
            size70x70: null,
            size125x125: null,
          },
          title: null,
          since: null,
        },
        status: null,
        division: null,
      },
    };
  },
  computed: {
    tabs() {
      const allTabs = [
        {
          id: 1,
          name: "Stammdaten",
          route: `general`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_GENERAL_update}`,
        },
        {
          id: 2,
          name: "Kontaktdaten",
          route: `contact`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CONTACT_update}`,
          disabled: true,
        },
        {
          id: 3,
          name: "Chronik",
          route: `chronicle`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CHRONICLE_update}`,
          disabled: true,
        },
        {
          id: 4,
          name: "Anwesenheit",
          route: `attendances`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_ATTENDANCE_update}`,
        },
        {
          id: 5,
          name: "Fristen",
          route: `deadlines`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CHRONICLE_update}`,
        },
        {
          id: 6,
          name: "Fertigkeiten",
          route: `certificates`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_CERTIFICATES_update}`,
        },
        // {
        //   id: 7,
        //   name: "Untersuchungen",
        //   route: `physicals`,
        //   disabled: true,
        //   permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_PHYSICALS_update}`,
        // },
        {
          id: 8,
          name: "Notfallkontakte",
          route: `emergency-contacts`,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_EMERGENCY_CONTACTS_update}`,
          disabled: true,
        },
        { id: 11, name: "Inventar", route: `inventory`, disabled: true },
        {
          id: 12,
          name: "Abrechnung",
          route: `accounting`,
          disabled: true,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_ACCOUNTING_update}`,
        },
        {
          id: 13,
          name: "Jugendfeuerwehr",
          route: `youth-group`,
          collectionId: "personnelRecords_youthGroup",
          disabled: true,
          permission: `${MEMBER_MANAGEMENT_PERSONNEL_RECORDS_YOUTH_GROUP_update}`,
        },
        { id: 99, name: "Änderungshistorie", route: ``, disabled: true },
      ];
      return allTabs.filter((tab) => {
        return this.checkPermission(tab.permission);
      });
    },
    backRoute() {
      return this.$route.path.includes ===
        "/personnel-records/" + this.$route.params.itemId
        ? "member-management-personnel-records"
        : "";
    },
    personnelRecords() {
      return this.$store.state.memberManagement.personnelRecords;
    },
  },
  watch: {
    $route: "initialize",
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.getPersonnelRecord();
    },
    getPersonnelRecord() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("personnelRecords_general")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.personnelRecord = doc.data();
            this.dataIsLoading = false;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    editItem() {
      this.$router.push({
        name: `member-management-personnel-records-edit-${
          this.activeTab || "general"
        }`,
        params: {
          organizationId: this.$route.params.organizationId,
          itemId: this.$route.params.itemId,
        },
      });
    },
    checkPermission(item) {
      if (item == "" || item == undefined) {
        return true;
      } else {
        return this.$store.getters["organization/checkPermissionByID"](item);
      }
    },
  },
};
</script>

<style></style>
